module.exports = __webpack_public_path__ + "img/hyal-6.bb803094.png";